interface KeyList {
  projectName: string;
  projectUrl: string;
  apiURL: string;
  grpcURL: string;
}

const MyConstant = {
  keyList: {
    projectName: 'Silomed-AI-web',
    projectUrl: '',
    apiURL: "https://api.teqbahn.com/teqverse-api/",
    grpcURL: 'https://api.teqbahn.com',
  } as KeyList,
};

export default MyConstant;
